import { post } from './request';

export type FollowUpRewriteContext =
  | 'ESTATES'
  | 'CANCELED'
  | 'CAPITALIZATION'
  | 'HIRED_DATA'
  | 'BOND_INSURANCES'
  | 'CLAIMS';

export interface RewriteFollowUpResponse {
  message: string;
}

export async function rewriteFollowUp(
  message: string,
  context?: FollowUpRewriteContext | string,
): Promise<RewriteFollowUpResponse> {
  return await post('/follow-ups/rewrite', { message, context });
}
